export default {"src":"/_next/static/media/isologo.baddbc6a.svg","height":60,"width":60};